/* eslint max-len: 0 */
import { MeRepository, UsersRepository, LicensesRepository, AppIntegrationsRepository, ActivationCodesRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$state',
    'DeployRestService', 'Util', '$scope'];

class DeviceCardController {

    constructor(
        $state, DeployRestService,
        Util, $scope,
    ) {

        this.$state = $state;
        this.$scope = $scope;
        this.DeployRestService = DeployRestService;
        this.MeRepository = MeRepository;
        this.UsersRepository = UsersRepository;
        this.LicensesRepository = LicensesRepository;
        this.ActivationCodesRepository = ActivationCodesRepository;
        this.AppIntegrationsRepository = AppIntegrationsRepository;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$scope.product = AppIntegrationsRepository.getAppName('fass0');

        this.Util = Util;
        this.myId = MeRepository.getMyId();
        this.devicesView = localStorage.getItem('DevicesView');

        // direct binding for licenses
        const licensesObservable = LicensesRepository.getObservable();
        const licensesSubscriber =
            licensesObservable.subscribe(data => this.onNextLicense(data), () => { }, () => { });

        $scope.$on('$destroy', () => {

            licensesSubscriber.dispose();

        });

        const activationCodes = this.ActivationCodesRepository.getAll();
        const hasAia = activationCodes.find(activationCode => activationCode.attributes.app === 'adwp1');
        this.$scope.hasOnlyAiaLicense = !!(activationCodes.length === 1 && hasAia);

    }

    detectIfDeviceHasLicenses() {

        const activationCodesRepo = this.ActivationCodesRepository.getAll();
        const licensesRepo = this.LicensesRepository.getAll();
        this.$scope.userHasSubscriptions =
            activationCodesRepo.length > 0 || licensesRepo.length > 0;

    }

    onNextLicense() {

        this.detectIfDeviceHasLicenses();

    }

    deployOn(os) {

        Mixpanel.send('ConnectWeb Add New Device Click', { Page: 'My Devices', 'Device Os': os });
        this.$state.go(
            'root.dashboard.devices.ltb.deploy',
            {
                ltb: 'deploy',
                resourceId: 'new',
                os,
            }, {
                reload: false,
            },
        );

    }

    deployOnCategory(category) {

        this.$state.go('root.dashboard.devices.ltb.deploy', {
            ltb: 'deploy',
            resourceId: 'new',
            deviceCategory: category,
        }, {
            reload: false,
        });

    }

    resendDevice(device) {

        this.DeployRestService.deployOnDevice({
            appId: CWCONFIG.defaultDeployedAppId[device.attributes.os],
            userId: device.relationships.user.data.id,
            deviceId: device.id,
            meta: {
                resend: true,
                force_send_email: true,
            },
        }).then(() => {

            Alert.success({
                message: 'cw.device.resend.success',
                icon: {
                    cssClasses: `icon-${this.Util.deepFind(device, 'attributes.type')}`,
                },
            });

        }).then(null, (error) => {

            const errorCode =
                (error.data.errors && error.data.errors[0]) ? error.data.errors[0].code : false;

            switch (errorCode) {

            case '1208': // maximum number of SMS exceeded

                Alert.error({
                    message: 'cw.device.resend.sms_error',
                    icon: {
                        cssClasses: `icon-${this.Util.deepFind(device, 'attributes.type')}`,
                    },
                });

                break;

            default:

                Alert.error({
                    message: 'cw.device.resend.error',
                    icon: {
                        cssClasses: `icon-${this.Util.deepFind(device, 'attributes.type')}`,
                    },
                });

            }

        });

    }

    /**
     * @ngdoc function
     * @name controllers.DeviceCardController#getUserName
     * @methodOf controllers.DeviceCardController
     * @function
     *
     * @description
     * Return the name of the user who owns the device.
     *
     * @param {object} device A device object.
     */
    getUserName(device) {

        const user = this.UsersRepository.getById(this.Util.deepFind(device, 'relationships.user.data.id'));

        const firstName = this.Util.deepFind(user, 'attributes.first_name');
        const lastName = this.Util.deepFind(user, 'attributes.last_name');

        return (`${firstName || ''} ${lastName || ''}`);

    }

    sendMixpanelEvent(event, eventDetails) {

        if (event === 'tooltip') {

            Mixpanel.send('ConnectWeb Device Tooltip Click', {
                Tooltip: eventDetails,
            });

        } else if (event === 'add_device') {

            Mixpanel.send('ConnectWeb Device Add Device List View Click');

        } else if (event === 'device_details') {

            Mixpanel.send('ConnectWeb Device Details Click');

        }

    }

    viewDetailsFromListView(deviceId) {

        if (this.devicesView === 'list') {

            this.$state.go('root.dashboard.device-details', {
                resourceId: deviceId,
                tab: 'apps',
            });

        }

    }

}

class DeviceCardDirective {

    constructor() {

        this.template = require('./device-card.html');
        this.restrict = 'EA';
        this.replace = true;
        this.scope = { source: '=', category: '=' };

        _controllerDependencies.push((
            $state, DeployRestService,
            Util, $scope,
        ) =>
            new DeviceCardController(
                $state, DeployRestService,
                Util, $scope,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'deviceCardCtrl';

    }

}

_directiveDependencies.push(() => new DeviceCardDirective());


angular.module('directives')
    .directive('deviceCard', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/device-card/device-card.js